import differenceInMilliseconds from'../differenceInMilliseconds/index.js';import requiredArgs from'../_lib/requiredArgs/index.js';/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */export default function differenceInSeconds(dirtyDateLeft,dirtyDateRight){requiredArgs(2,arguments);var diff=differenceInMilliseconds(dirtyDateLeft,dirtyDateRight)/1000;return diff>0?Math.floor(diff):Math.ceil(diff);}